import { MessageDescriptor } from '@lingui/core';
import { msg } from '@lingui/core/macro';
import { useLingui } from '@lingui/react/macro';
import classNames from 'classnames';
import { ChampionshipMediaKindRow } from 'modules/championship/domain/graphql/championship-media';
import React from 'react';
import UDText, { UDTextVariant } from 'ud-ui/components/text';

/** Готовность типа медиа к генерации: шаблон есть / шаблона нет / тип ещё не поддержан. */
export type MediaKindState = 'ready' | 'missing' | 'soon';

export function mediaKindState(row: ChampionshipMediaKindRow): MediaKindState {
  if (!row.supported || row.blockedReason === 'unsupported') return 'soon';
  if (row.blockedReason === 'no_template' || !row.templateName) return 'missing';
  return 'ready';
}

/** Подписи статусов. Ими же скелетон вкладки меряет ширину плашки пилюли. */
export const MEDIA_KIND_STATUS_LABELS: Record<MediaKindState, MessageDescriptor> = {
  ready: msg`Готов к генерации`,
  missing: msg`Нет шаблона`,
  soon: msg`Скоро`,
};

/** Форма и типографика пилюли — общие для статуса и его плашки в скелетоне. */
export const MEDIA_KIND_STATUS_CLASS = 'rounded-pill inline-flex h-7 items-center px-3 whitespace-nowrap';
export const MEDIA_KIND_STATUS_VARIANT: UDTextVariant = 'text-2';

/** Тон пилюли — цвет состояния темы; у «скоро» своего исхода нет, он нейтральный. */
const TONE_CLASS: Record<MediaKindState, string> = {
  ready: 'bg-CaseSuccessSurface text-CaseSuccessText',
  missing: 'bg-CasePendingSurface text-CasePendingText',
  soon: 'bg-surfaceSunken text-inkSecondary',
};

interface MediaKindStatusProps {
  state: MediaKindState;
}

/**
 * Статус типа медиа на вкладке «Медиа» турнира — пилюля со словом, а не значок: прежний «○»
 * походил на радиокнопку и ничего не сообщал (IMGM-1509).
 */
const MediaKindStatus = ({ state }: MediaKindStatusProps) => {
  const { t } = useLingui();

  return (
    <UDText
      as="span"
      variant={MEDIA_KIND_STATUS_VARIANT}
      className={classNames(MEDIA_KIND_STATUS_CLASS, TONE_CLASS[state])}
      data-testid="media-kind-status"
      data-state={state}
    >
      {t(MEDIA_KIND_STATUS_LABELS[state])}
    </UDText>
  );
};

export default React.memo(MediaKindStatus);
